/* eslint-disable no-useless-escape */
export const validations = {
  onlyNumbers: {
    message: 'Please only enter numbers',
    value: /^[0-9]+$/,
  },
  phone: {
    message: 'Please enter a valid phone number format',
    // (XXX) XXX-XXXX
    value: /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/,
  },
  account: {
    message: 'Please enter a valid account number between 4 and 12 numbers',
    // XXXX
    value: /^[0-9]{4,12}$/,
  },
  ssn: {
    message: 'Please enter the last 4 digits of your social security number',
    // XXXX
    value: /^[0-9]{1,4}$/,
  },
  taxid: {
    message: 'Please enter the last 4 digits of your federal tax ID',
    // XXXX
    value: /^[0-9]{1,4}$/,
  },
  email: {
    message: 'Please enter a valid email.',
    // https://stackoverflow.com/questions/201323/how-can-i-validate-an-email-address-using-a-regular-expression
    value:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  },
};

export const masks = {
  // mask telephone values to (000) 000-0000 format
  // (https://stackoverflow.com/a/59689167)
  tel: (value: string) => {
    return value
      .replace(/\D/g, '')
      .replace(
        /^(\d{1,3})(\d{0,3})(\d{0,4})(\d{0,4})$/,
        (_, p1, p2, p3) => `(${p1}${p2 ? ') ' : ''}${p2}${p3 ? '-' : ''}${p3}`
      );
  },
  removeTel: (maskedString: string | undefined) => {
    return maskedString?.replace(/[^+\d]+/g, '');
  },
  onlyNumbers: (val: string) => {
    return val.replace(/\D+/, '');
  },
};
